import BaseCommand from "@/models/api/commands/BaseCommand";

export class ChangeComponentDescriptionCommand extends BaseCommand {
  CommandName = "ChangeComponentDescription";
  Command: { TmpId: string; Value: string };
  constructor(sessionId: string, operationId: string, tmpId: string, value: string) {
    super(sessionId, operationId);
    this.Command = { TmpId: tmpId, Value: value };
  }
}
